import { CalendarDays, Clock3, GraduationCap, MapPin, UserRound } from "lucide-react";
import { formatCalendarDate } from "@/utils/dateDisplay";

export const AttendanceScheduleCard = ({ student, schedule }) => (
  <section className="attendance-schedule-card" data-testid="attendance-schedule-card">
    <div className="attendance-card-kicker"><GraduationCap size={15} /> DATA KEGIATAN ANDA</div>
    <div className="attendance-student-identity">
      <div><UserRound size={20} /></div>
      <span><small>MAHASISWA</small><strong data-testid="attendance-student-name">{student.nama_mahasiswa}</strong><em data-testid="attendance-student-campus">{student.nim} · {student.nama_pt}</em></span>
    </div>
    <dl className="attendance-schedule-grid">
      <div><dt><MapPin size={15} /> Lokasi</dt><dd data-testid="attendance-schedule-location">{schedule.lokasi}</dd></div>
      <div><dt><CalendarDays size={15} /> Tanggal</dt><dd data-testid="attendance-schedule-date">{formatCalendarDate(schedule.tanggal, "long")}</dd></div>
      <div><dt><Clock3 size={15} /> Waktu</dt><dd data-testid="attendance-schedule-time">{schedule.jam} WIB</dd></div>
    </dl>
  </section>
);